import React, { memo, useCallback, useEffect, useState } from 'react';
import { Row, Col, Tooltip, Spin } from 'antd';
import './styles.scss';
import { number_format, sortAtoZ } from '@utils/widget';
import { useSelector } from 'react-redux';
import { API } from '@service';

function isInvalidNumber(value) {
  return value === null || value === undefined || value === '-';
}

function getNumberContent(value) {
  return isInvalidNumber(value) ? '-' : number_format(value, 0);
}

function getCountriesContent(count, names = []) {
  return isInvalidNumber(count) ? (
    '-'
  ) : (
    <>
      {count}
      <CountryTooltip countries={names.filter((i) => Boolean(i))} />
    </>
  );
}

function Cell({ label, content }) {
  return (
    <Col className="headcount-table-cell" span={6}>
      <span>{label}</span>
      <span className="headcount-table-cell-content">
        {isInvalidNumber(content) ? '-' : content}
      </span>
    </Col>
  );
}

function CountryTooltip({ countries = [] }) {
  if (!countries.length) {
    return null;
  }
  return (
    <Tooltip
      title={
        <div className="questionnaires-headcount-tooltip">
          {countries.sort(sortAtoZ).join(', ')}
        </div>
      }
      placement="left"
      getPopupContainer={() =>
        document.getElementsByClassName('questionnaires-headcount-table')[0]
      }
    >
      <span className="appkiticon icon-information-fill" />
    </Tooltip>
  );
}

function HeadcountTable() {
  const projectId = useSelector((state) => state.common.currentId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const fetchData = useCallback(
    async (projectId) => {
      if (!projectId) {
        return;
      }
      setLoading(true);
      const res = (await API.getHeadcountReferenceData(projectId)) || {};
      setData(res);
      setLoading(false);
    },
    [projectId],
  );

  useEffect(() => {
    fetchData(projectId);
  }, [projectId]);
  return (
    <div className="questionnaires-headcount-table">
      <Spin spinning={loading}>
        <Row gutter={0} className="headcount-table-header">
          <Col span={12}>Buyer</Col>
          <Col span={12}>Target</Col>
        </Row>
        <Row gutter={0}>
          <Cell
            label="Financial Statement"
            content={getNumberContent(data.buyerFinancialStatement)}
          />
          <Cell
            label="Dun & Bradstreet"
            content={getNumberContent(data.buyerDunBradstreet)}
          />
          <Cell
            label="Financial Statement"
            content={getNumberContent(data.targetFinancialStatement)}
          />
          <Cell
            label="Dun & Bradstreet"
            content={getNumberContent(data.targetDunBradstreet)}
          />
        </Row>
        <Row gutter={0}>
          <Cell
            label="Countries"
            content={getCountriesContent(
              data.buyerOfficeCountryCount,
              data.buyerOfficeCountryNames,
            )}
          />
          <Cell
            label="Countries"
            content={getCountriesContent(
              data.buyerPresence,
              data.buyerCountryNames,
            )}
          />
          <Cell
            label="Countries"
            content={getCountriesContent(
              data.targetOfficeCountryCount,
              data.targetOfficeCountryNames,
            )}
          />
          <Cell
            label="Countries"
            content={getCountriesContent(
              data.targetPresence,
              data.targetCountryNames,
            )}
          />
        </Row>
        <Row gutter={0}>
          <Cell label="Offices" content={data.buyerOfficeCount} />
          <Cell label="Branches" content={data.buyerBranches} />
          <Cell label="Offices" content={data.targetOfficeCount} />
          <Cell label="Branches" content={data.targetBranches} />
        </Row>
        <Row gutter={0}>
          <Cell content="" />
          <Cell label="Subsidiaries" content={data.buyerSubsidiaries} />
          <Cell content="" />
          <Cell label="Subsidiaries" content={data.targetSubsidiaries} />
        </Row>
      </Spin>
    </div>
  );
}

export default memo(HeadcountTable);
